/**
 * A identidade deste build do front — gravada pelo `define` do vite.config.ts,
 * onde está explicado de onde vem cada parte.
 */

import type { ItemDaNovidade, NovidadesDaVersao } from "./novidades"

export interface Build {
  versao: string
  /** SHA completo, ou "" quando o build não soube de onde veio. */
  commit: string
  /** Instante do build, ISO em UTC. */
  build: string
}

export const esteBuild: Build = { versao: __VERSAO__, commit: __COMMIT__, build: __BUILD__ }

/** As notas do NOVIDADES.md que entraram neste build — a versão no ar e as anteriores. */
export const novidadesDesteBuild: NovidadesDaVersao[] = __NOVIDADES__

/**
 * As notas que vieram de fora — do `versao.json` publicado ou do `/health` da API.
 *
 * Desconfiada como o {@link houveDeploy}: o que não tiver a forma certa fica de fora,
 * em vez de derrubar o rodapé ou o aviso. Um build antigo, sem notas, dá lista vazia.
 */
export function notasValidas(bruto: unknown): NovidadesDaVersao[] {
  if (!Array.isArray(bruto)) return []
  return bruto.flatMap((n): NovidadesDaVersao[] => {
    if (typeof n !== "object" || n === null) return []
    const { versao, itens } = n as { versao?: unknown; itens?: unknown }
    if (typeof versao !== "string" || !Array.isArray(itens)) return []
    const validos = itens.flatMap((i): ItemDaNovidade[] => {
      const { tipo, texto } = (i ?? {}) as { tipo?: unknown; texto?: unknown }
      if (typeof texto !== "string" || !texto.trim()) return []
      return [{ tipo: tipo === "novo" || tipo === "correcao" ? tipo : null, texto }]
    })
    return [{ versao, itens: validos }]
  })
}

/** "v2.0.0 · a1b2c3d" — o que se lê no rodapé e se cola num chamado. */
export function rotuloDaVersao(versao: string, commit?: string | null): string {
  return commit ? `v${versao} · ${commit.slice(0, 7)}` : `v${versao}`
}

/**
 * O `versao.json` publicado é de outro build que não o desta aba?
 *
 * Qualquer coisa que não seja o JSON esperado conta como "não" — inclusive o
 * index.html que o fallback de SPA do nginx devolveria se o arquivo sumisse.
 * Na dúvida, não incomodar ninguém.
 */
export function houveDeploy(publicado: unknown, atual: string = esteBuild.build): boolean {
  if (typeof publicado !== "object" || publicado === null) return false
  const build = (publicado as { build?: unknown }).build
  return typeof build === "string" && build !== "" && build !== atual
}
